import styled from 'styled-components'

export const StickyHeader = styled.div`
  position: sticky;
  top: 0;
  padding: 5px;
  background-color: #fafafa;
  border-radius: 5px;
  z-index: 2;
`
